import { fetch } from '../utils/request';

const getUrl = (path) => `${process.env.MONO_API}${path}`;

export default {
  /**
   * Get all registered controller devices for the represented business unit.
   * @returns {Promise<Object>}
   */
  getDevices() {
    return fetch(getUrl('/production-controllers/devices'));
  },

  /**
   * Assign or move a controller. If productionId is null, unassigns it.
   * @param {string|number} deviceId
   * @param {string|null} productionId
   * @returns {Promise<Object>}
   */
  updateDeviceAssignment(deviceId, productionId) {
    return fetch(getUrl(`/production-controllers/devices/${deviceId}/assignment`), {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ productionId }),
    });
  },

  /**
   * Update the user-facing name of a registered controller device.
   * @param {string|number} deviceId
   * @param {string} name
   * @returns {Promise<Object>}
   */
  updateDevice(deviceId, name) {
    return fetch(getUrl(`/production-controllers/devices/${deviceId}`), {
      method: 'PATCH',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({ name }),
    });
  },
};
